import React from 'react';
import { getPolyglot } from '../../../../../../i18n';
import { GroupActionsProps } from './GroupActions';
import { useAppSelector } from '../../../../../../redux/store.model';
import { groupButtonsRightsSelector } from '../../../../../../redux/groups/selectors/groupRightsSelectors';
import {
  ButtonIcon,
  MenuItemPrimary,
} from '../../../../../../theme/components';
import { useNavigate } from 'react-router-dom';
import { ChartIcon } from '../../../../../../theme/icons';
import { ListItemIcon } from '@mui/material';
import useModuleSelected from '../../../../navigations/useModuleSelected';

const iconId = 'chart line';
const icon = <ChartIcon height={'1em'} />;
const iconGrid = <ChartIcon height={'1em'} />;
export function GroupHistoryAction(props: GroupActionsProps) {
  const { group, variant } = props;
  const polyglot = getPolyglot();
  const navigate = useNavigate();

  const openControlUnitHistory = (e: React.MouseEvent) => {
    const url = `/devicemanager/group/${group?.id}/history`;
    navigate(url);
  };

  const moduleSelected = useModuleSelected();
  const selected = moduleSelected === 'history';

  const tooltipContent = polyglot.t('device.monitoring.title');
  if (!group) return null;
  if (variant === 'menuItem')
    return (
      <MenuItemPrimary
        onClick={openControlUnitHistory}
        className={`icon-${iconId} group-${group.id}`}
        selected={selected}
      >
        <ListItemIcon sx={{ color: 'inherit' }}>{iconGrid}</ListItemIcon>
        {tooltipContent}
      </MenuItemPrimary>
    );
  return (
    <React.Fragment>
      <ButtonIcon
        className={`icon-${iconId} group-${group.id}`}
        tooltip={tooltipContent}
        onClick={openControlUnitHistory}
        selected={selected}
        sx={{ width: '45px', height: '45px' }}
      >
        {icon}
      </ButtonIcon>
    </React.Fragment>
  );
}
export default GroupHistoryAction;
